export default __webpack_public_path__ + "static/media/dex.00a25c0e.png";